import { useDispatch, useSelector } from 'react-redux';
import * as React from 'react';

import { getIsOpen } from '../../selectors/newAnswer';
import { getAnswerTargetId } from '../../selectors/common';
import { getIsReviewTab } from '../../selectors/tabs';
import { addAnswerActions } from '../../actions/newAnswer/addAnswerActions';
import { addQuestionAnswerActions } from '../../actions/newAnswer/addQuestionAnswerActions';
import { TThunkDispatch } from '../../types/redux';

export const useNewbuildingsNewReplySubmitHandler = () => {
  const dispatch = useDispatch<TThunkDispatch>();

  const openId = useSelector(getIsOpen);
  const targetId = useSelector(getAnswerTargetId(openId));
  const isReview = useSelector(getIsReviewTab);

  return React.useCallback(() => {
    if (!openId) {
      return;
    }

    if (isReview) {
      dispatch(addAnswerActions({ reviewId: targetId, type: openId.type }));
    } else {
      dispatch(addQuestionAnswerActions({ questionId: targetId, type: openId.type }));
    }
  }, [dispatch, isReview, openId, targetId]);
};
